module.exports = __webpack_public_path__ + "img/escrivaninhas.af048f0a.webp";